var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('WidgetsDropdown'),_c('CCard',[_c('CCardHeader',[_c('CIcon',{attrs:{"name":"cil-grid"}}),_vm._v("Agents ")],1),_c('CCardBody',[_c('CustomersTable')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }